import { Box, Button } from '@mui/material';
import { useContext, useState } from 'react';
import Joyride from 'react-joyride';
import { ToolContext } from '../../../../core/context/ToolContext';
import { rqx } from '../../../../core/request/API';
import { env } from '../../../../core/Env';

export const CustomComponent = ({ step, index, totalSteps, primaryProps, closeProps, tooltipProps }) => {
    return (
        <Box {...tooltipProps} width="340px" p={2} bgcolor="#fff" borderRadius="8px">
            <Box fontSize="14px" fontWeight="600">{step.title}</Box>
            <Box fontSize="12px" py="4px">{step.content}</Box>

            <Box width="100%" display="flex" justifyContent="flex-end"  gap="4px">
                <Button {...closeProps} variant="text" sx={{ fontSize: '12px', p: '4px 16px' }}>
                    Skip
                </Button>
                <Button {...primaryProps} variant="contained" disableElevation sx={{fontSize: '12px', p: '4px 16px'}}>
                    {index === 10 ? "Got it!" : "Next"}
                </Button>
            </Box>
        </Box>
    );
};

const steps = [
    {
        target: '.first-step',
        title: 'Publication',
        content: 'You will find publication',
        placement: 'right',
        disableBeacon: true,
        disableScrollParentFix: true,
        disableScrolling: true,
    },
    {
        target: '.second-step',
        title: 'Save',
        content: 'You will find your saved items',
        placement: 'right',
        disableBeacon: true,
    },
    {
        target: '.third-step',
        title: 'Help',
        content: 'Resources that guide users through personalizing their experience, following step-by-step instructions, and finding quick answers.',
        placement: 'right',
        disableBeacon: true,
    },
    {
        target: '.fourth-step',
        title: 'Support',
        content: 'Access customer assistance for troubleshooting and guidance to make the most out of the product.',
        placement: 'right',
        disableBeacon: true,
    },
    {
        target: '.fifth-step',
        title: 'Get App',
        content: 'Download the app for easy access.',
        placement: 'top',
        disableBeacon: true,
    },
    {
        target: '.sixth-step',
        title: 'Search',
        content: 'Find what you’re looking for.',
        placement: 'right',
        disableBeacon: true,
    },
    {
        target: '.seventh-step',
        title: 'Bible',
        content: 'Read God word anytime anywhere',
        placement: 'right',
        disableBeacon: true,
    },
    {
        target: '.eighth-step',
        title: 'POFChat',
        content: 'Get in touch with people on POFChat.',
        placement: 'right',
        disableBeacon: true,
    },
    {
        target: '.ninth-step',
        title: 'Notification',
        content: 'Check your latest notifications here.',
        placement: 'right',
        disableBeacon: true,
    },
    {
        target: '.tenth-step',
        title: 'My Tools',
        content: 'Quick-access shortcuts to all available tools to help you use key features faster.',
        placement: 'right',
        disableBeacon: true,
    },
    {
        target: '.eleventh-step',
        title: 'Profile',
        content: 'Manage your settings, preferences, and personal details while exploring additional features.',
        placement: 'left',
        disableBeacon: true,
    },
];


export const General = () => {
    const { tool_state, personalization_state } = useContext(ToolContext);
    const { __SESSION } = tool_state;
    const { walkthrough } = personalization_state

    const [stepIndex, setStepIndex] = useState(0);

    const user_id = window.atob(__SESSION.data.ainfo.aid).slice(8);
    const tool_id =  process.env.REACT_APP_TID_PSL;

    const handleJoyrideCallback = async (data) => {
        const { status, action, index, type } = data;
        
        let body = {
            user_id: user_id,
            tool_id: tool_id,
            feature_name: 'onboarding',
            personalization:[{sf_name: 'onboading', status: 1}, {sf_name: 'walkthrough', status: 1}]
        }

        if (type === 'step:after' && action === 'next') {
            setStepIndex(index + 1);
        }

        if (status === "finished") {
            const res = await rqx.post(`<<global>>/${env()}/personalization/create`, body)
            if (res.msg === 'success') {
                walkthrough.set(prev => ({...prev, general: false}))
            }
        }
        
        if (['close', 'stop'].includes(action)) {
            walkthrough.set(prev => ({...prev, general: false}))
            setStepIndex(0);
            await rqx.post(`<<global>>/${env()}/personalization/create`, body)
        }
    };	
    
    return (
            <Joyride
                continuous
                disableOverlayClose={true}
                run={walkthrough.data.general}
                steps={steps}
                stepIndex={stepIndex}
                showSkipButton={true}
                callback={handleJoyrideCallback}
                tooltipComponent={CustomComponent}
            />

    );
};
